var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFilterOpenCloseIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.8125 13.375V11.75H10.0625V13.375H6.8125ZM3.5625 9.3125V7.6875H13.3125V9.3125H3.5625ZM1.125 5.25V3.625H15.75V5.25H1.125Z",
    fill: "#4859FA"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFilterOpenCloseIcon);
export default __webpack_public_path__ + "static/media/filterOpenCloseIcon.cb028cc6dac19fb55edf431b4f6932b7.svg";
export { ForwardRef as ReactComponent };